// extracted by mini-css-extract-plugin
module.exports = {"login-content":"otpForm_login-content__W56Vj","edit-phone":"otpForm_edit-phone__oOd_M"};